import { useQuery } from '@tanstack/react-query';

import { appConfig } from '../../../appConfig';
import { contentDeliveryApi } from '../../episerver/api/contentDeliveryApi';
import type { EpiEcommerceSettingsPageType } from '../../episerver/models/epiEcommerceSettingsPageType';
import { ecommerceQueryKeys } from '../ecommerceQueryKeys';

const useEcommerceSettings = () => {
    const query = useQuery<EpiEcommerceSettingsPageType>({
        queryKey: ecommerceQueryKeys.settings,
        queryFn: () =>
            contentDeliveryApi.getContentExtended<EpiEcommerceSettingsPageType>(
                appConfig.coopSettings.ecommerce.settingsContentId,
            ),
        staleTime: Infinity,
    });

    return query;
};

export default useEcommerceSettings;
